import { render, staticRenderFns } from "./AppFooter.vue?vue&type=template&id=9d300b4a&scoped=true"
var script = {}
import style0 from "./AppFooter.vue?vue&type=style&index=0&id=9d300b4a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d300b4a",
  null
  
)

export default component.exports